import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth";

export function useLoginAsExpert() {
  const router = useRouter();
  const authStore = useAuthStore();
  const isLoading = ref(false);

  const loginAs = async (userId: number, redirectPath = "/expert/dashboard") => {
    if (isLoading.value) return;
    isLoading.value = true;
    try {
      await authStore.loginAs(userId);
      await router.push(redirectPath);
    } catch (error) {
      console.error("[useLoginAsExpert] Failed:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    loginAs,
    isLoading,
  };
}
